import { autoinject } from 'aurelia-dependency-injection';

import { PortalPlugin } from './PortalPlugin';
import { PortalFramework } from './PortalFramework';

export type PortalProvider = ({ portalFramework }: { portalFramework: PortalFramework }) => Promise<PortalPlugin>;
export type PluginRegistration = PortalPlugin | PortalProvider;

// typescript guard function to differentiate possible registration types
const isPortalProvider = (registration: PluginRegistration): registration is PortalProvider => registration instanceof Function;

/**
 * Plugins can either be a PortalPlugin object, or an async function returning a promise of a PortalPlugin object.
 * This resolver figures out which it is, and returns the resolved PortalPlugin object.
 */
@autoinject
 export class RegistrationResolver {

  constructor(private portalFramework: PortalFramework) { }

  resolve = async (registration: PluginRegistration) => {

    if (isPortalProvider(registration)) {
      return await registration({ portalFramework: this.portalFramework });
    } else {
      return registration;
    }
  }
}



// WEBPACK FOOTER //
// ./src/framework/RegistrationResolver.ts